<template>

<com-content :loading="is.loading" :text="text" :empty="!events.length && !offers.length && loggedin" class="offers-wrapper">

    <app-wrapper class="offers" v-if="loggedin">

        <app-offer v-for="(offer, index) in offers" :key="'o' + index" :item="offer" :noexpiry="page.offers_expiry" :hideBusiness="true" :label="page.offers_offers" />
        <app-event v-for="(event, index) in events" :key="'e' + index" :item="event" :hideBusiness="true" :label="page.offers_events" />

    </app-wrapper>

    <app-wrapper v-if="!loggedin">

        <app-text :center="true" class="offers-authorise">

            <app-group>

                <h2>{{ page.offers_authorise }}</h2>
                    
                <app-button to="Login/Customer" :query="{redirect: $route.path}" :fixed="true" theme="blue" :text="page.offers_button_login" />
                <app-button to="Register/Customer" :query="{redirect: $route.path}" :fixed="true" theme="plain" :text="page.offers_button_register" />

            </app-group>

        </app-text>

    </app-wrapper>

</com-content>

</template>

<script>

import comContent from './common/Content'

export default {

    components: {
        'com-content': comContent
    },

    data: function() {

        return {
            is: {
                loading: false
            },
            events: [],
            offers: []
        }

    },

    computed: {

        text: function() {

            return {
                empty: this.page.offers_empty
            }

        }

    },

    created: function() {

        this.fetch()

    },

    methods: {

        fetch: function() {

            this.is.loading = true

            this.$api.request('business/offers', {
                slug: this.page.business.slug
            }).then(function(json) {

                this.offers = json.offers
                this.events = json.events

                this.is.loading = false

            }.bind(this))

        }

    }

}

</script>

<style scoped>

.offers-wrapper {
    padding: 20px 0px!important;
}

.is-mobile .offers-wrapper {
    padding: 10px 0px!important;
}

.offers {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
}

.offers-authorise {
    width: 480px!important;
    margin: 0px auto;
    margin-top: 40px;
}

.offers-authorise >>> .button {
    width: auto;
    margin: 0px auto;
}

.is-mobile .offers-authorise {
    width: 100%!important;
    margin-top: 20px;
}

</style>